/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PossibleStoreDto
 */
export interface PossibleStoreDto {
    /**
     * 
     * @type {number}
     * @memberof PossibleStoreDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PossibleStoreDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the PossibleStoreDto interface.
 */
export function instanceOfPossibleStoreDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PossibleStoreDtoFromJSON(json: any): PossibleStoreDto {
    return PossibleStoreDtoFromJSONTyped(json, false);
}

export function PossibleStoreDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossibleStoreDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PossibleStoreDtoToJSON(value?: PossibleStoreDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

